import React, { useEffect, useRef, useState } from 'react';
import SaveModal from './saveModal';

function GetIATAModal({ IsNull, IsGroup, onClose, setModalAgencyData }) {
    const fileInputRef = useRef(null);
    const [add, setAdd] = useState('🏠주소 찾기');
    const [fileName, setFileName] = useState('📂 파일 선택');
    const [modalAction, setModalAction] = useState(null);
    const [modalContent, setModalContent] = useState(null);
    const [saveStatus, setSaveStatus] = useState(true);

    // 🔹 로컬 상태에서 모든 입력값 관리
    const [AgencyData, setAgencyData] = useState({
        kornName: '',
        saupNumb: '',
        iataCode: '',
        teleNumb: '',
        faxiNumb: '',
        headName: '',
        postCode: '',
        addr1: '',
        addr2: '',
        agentCity: '',
        agentCode: '',
        file: null,
    });

    // 🔹 파일 선택 버튼 클릭 시 숨겨진 input 활성화
    const handleClick = () => {
        fileInputRef.current.click();
    };

    // 🔹 파일 업로드 시 파일명 저장
    const nameChange = (event) => {
        if (event.target.files.length > 0) {
            const uploadedFile = event.target.files[0];
            setFileName(uploadedFile.name);

            // 기존 데이터 유지하면서 file 속성 업데이트
            setAgencyData((prev) => ({
                ...prev,
                file: uploadedFile,
            }));
        }
    };

    // 🔹 input 값 변경 시 상태 업데이트
    const handleChange = (e) => {
        const { name, value } = e.target;
        console.log(e)
        setAgencyData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    // 🔹 부모로 데이터 전달하는 함수
    const handleSubmit = () => {
        if (!AgencyData.kornName) {
            setModalAction(() => () => setSaveStatus(true));
            setModalContent('상호명을 입력해주세요.');
            setSaveStatus(false);
            return;
        } else if (!AgencyData.saupNumb) {
            setModalAction(() => () => setSaveStatus(true));
            setModalContent('사업자 등록번호를 입력해주세요.');
            setSaveStatus(false);
            return;
        } else if (!AgencyData.file) {
            setModalAction(() => () => setSaveStatus(true));
            setModalContent('사업자 등록증을 첨부해주세요.');
            setSaveStatus(false);
            return;
        }

        setModalAgencyData(AgencyData);
        onClose();
    };

    // 모달 창닫기 버튼
    const modalClose = () => {
        onClose();
    };

    useEffect(() => {
        if (AgencyData.addr1) {
            setAgencyData((prev) => ({
                ...prev,
                agentCity: prev.addr1.slice(0, 2) ?? '',
            }));
        }
    }, [AgencyData.addr1]);

    const handlePostcode = () => {
        new window.daum.Postcode({
            oncomplete: function (data) {
                console.log(data);

                setAdd((data.address).slice(0,20))
                setAgencyData((prev) => ({
                    ...prev,
                    ['addr1']: (data.address).slice(0,20),
                    ['addr2']: (data.address).slice(21),
                }));
            },
        }).open();
    };

    return (
        <div className={`modal ${IsNull === 'Business' ? 'show' : ''}`}>
            <div className='modalWrap'>
                <span style={{ margin: ' 0 0 0 auto', cursor: 'pointer' }} onClick={modalClose}>
                    ❌
                </span>
                <p className='modal-title'>대리점명이 검색되지 않습니다.</p>
                <p className='modal-content'>
                    아래 양식을 작성하여 제출해 주시면 확인 후 등록해드리겠습니다.
                </p>
                <div className='agentCheckWrap'>
                    <table className='signUp-table wpal-signup-modal-table'>
                        <tbody>
                            <tr className='firstTable-border'>
                                <th>
                                    <span className='important-value'>*</span>상호명
                                </th>
                                <td>
                                    <div className='table-padding'>
                                        <input
                                            type='text'
                                            placeholder='상호명 (15자 이내)'
                                            name='kornName'
                                            value={AgencyData.kornName}
                                            onChange={handleChange}
                                            maxLength={15}
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <span className='important-value'>*</span>사업자 등록번호
                                </th>
                                <td>
                                    <div className='table-padding'>
                                        <input
                                            type='text'
                                            placeholder='사업자 등록번호'
                                            maxLength={10}
                                            name='saupNumb'
                                            value={AgencyData.saupNumb.replace(/[^0-9]/g, '')}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    IATA CODE
                                </th>
                                <td>
                                    <div className='table-padding'>
                                        <input
                                            type='text'
                                            placeholder='IATA CODE'
                                            maxLength={8}
                                            name='iataCode'
                                            value={AgencyData.iataCode.replace(/[^0-9]/g, '')}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>대표자명</th>
                                <td>
                                    <div className='table-padding'>
                                        <input
                                            type='text'
                                            placeholder='대표자명(10자 이내)'
                                            name='headName'
                                            value={AgencyData.headName}
                                            onChange={handleChange}
                                            maxLength={10}
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>대표 전화</th>
                                <td>
                                    <div className='table-padding'>
                                        <input
                                            type='text'
                                            placeholder='대표 전화'
                                            name='teleNumb'
                                            value={AgencyData.teleNumb}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th><span className='important-value'>*</span>주소</th>
                                <td>
                                    <div className='table-padding'>
                                        <input
                                            type='text'
                                            className='hide'
                                            name='addr1'
                                            maxLength={20}
                                            onChange={handleChange}
                                        />
                                        <button
                                            className='wpal-signup-modal-input-button'
                                            onClick={handlePostcode}
                                        >
                                            <span className='button-text'>{add}</span>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                            <tr className='wpal-last-tr'>
                                <th>
                                    <span className='important-value'>*</span>사업자등록증
                                </th>
                                <td>
                                    <div className='table-padding'>
                                        <input
                                            type='file'
                                            ref={fileInputRef}
                                            onChange={nameChange}
                                            className='hide'
                                            name='file'
                                        />
                                        <button
                                            className='wpal-signup-modal-input-button'
                                            onClick={handleClick}
                                        >
                                            <span className='button-text'>{fileName}</span>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                {IsGroup ?
                    <></>:
                    <p className='modal-content'>
                        ※입력하신 정보로 WithPAL 회원 가입이 진행됩니다.
                        <br /> 이후 내부 검토가 이루어지며, 입력하신 정보가 확인되지 않거나 기준에
                        부합하지 않을 경우 회원 가입이 취소될 수 있습니다.
                    </p>
                }
                <div>
                    <button className='each-button' onClick={handleSubmit}>
                        확인
                    </button>
                </div>
            </div>
            <SaveModal content={modalContent} SaveBtn={saveStatus} onClose={modalAction} />
        </div>
    );
}

export default GetIATAModal;
